<script>
import { saveClientData, setClientDataValue } from '@/stores/clientData'
import { clientDataFields } from '@/stores/clientDataFields'
import fieldValidator from '@/helper/fieldValidator'

import TextField from '@/components/Form/TextField'
import PhoneField from '@/components/Form/PhoneField'
import BooleanGroupField from '@/components/Form/BooleanGroupField'
import BooleanField from '@/components/Form/BooleanField'
import _forEach from 'lodash/forEach'
import { watch } from 'vue'

export default {
  components: {
    TextField,
    PhoneField,
    BooleanGroupField,
    BooleanField,
  },
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    /* let saveTimeout
    const saveData = (field) => {
      if (field.value && field.error) {
        fieldValidator(field)
      }

      setTimeout(() => {
        if (field.name === 'phone') {
          if (field.value) {
            setClientDataValue(field.name, field.value)
          }
        } else {
          setClientDataValue(field.name, field.value)
        }
      }, 1)

      clearTimeout(saveTimeout)
      saveTimeout = setTimeout(() => {
        saveClientData()
      }, 50)
    }*/

    /*const updated = (field, value) => {
      if (value) {
        setClientDataValue(field.name, value)
      } else if (field.value) {
        setClientDataValue(field.name, field.value)
      }
    }*/

    let saveTimeout
    watch(
      clientDataFields,
      (fields) => {
        _forEach(fields, (field) => {
          if (field.value && field.error) {
            fieldValidator(field)
          }
          setClientDataValue(field.name, field.value)
        })

        clearTimeout(saveTimeout)
        saveTimeout = setTimeout(() => {
          saveClientData()
        }, 250)
      },
      {
        deep: true,
      }
    )

    return {
      clientDataFields,
    }
  },
}
</script>

<template>
  <form class="mb-14">
    <div>
      <div
        class="mb-6 last:mb-0"
        v-for="field in clientDataFields"
        :key="`uf${field.id}`"
      >
        <component
          :is="field.component"
          :id="field.id"
          :label="field.label"
          :placeholder="field.placeholder"
          :required="field.required"
          :error="field.error"
          :options="field.options || []"
          :disabled="locked"
          v-model="field.value"
        />
      </div>
    </div>
  </form>
</template>
